import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';

interface LoaderState {
  isLoading: boolean;
  progress: number;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly stateSubject = new BehaviorSubject<LoaderState>({ isLoading: false, progress: 0 });
  readonly state$: Observable<LoaderState> = this.stateSubject.asObservable();

  private countRequests = 0;
  private completeRequests = 0;
  private timeoutUnblock: NodeJS.Timeout | undefined;

  get isLoading(): boolean {
    return this.stateSubject.value.isLoading;
  }

  get progress(): number {
    return this.stateSubject.value.progress;
  }

  block(countRequests = 1): void {
    this.countRequests += countRequests;

    this.emitProgress(true);
  }

  unblock(countRequests = 1): void {
    this.completeRequests += countRequests;

    if (this.countRequests != 0 && this.completeRequests != 0) {
      if (this.completeRequests === this.countRequests) {
        this.emitProgress(true);

        this.countRequests = 0;
        this.completeRequests = 0;
        if (this.timeoutUnblock) {
          clearTimeout(this.timeoutUnblock);
        }
        this.timeoutUnblock = setTimeout(() => {
          this.emitProgress(false);
        }, 500);
      } else {
        this.emitProgress(true);
      }
    }
  }

  private emitProgress(isLoading = true): void {
    const progress = this.countRequests > 0
      ? Math.min(100, Number(((100 / this.countRequests) * this.completeRequests).toFixed(0)))
      : 0;

    this.stateSubject.next({ isLoading, progress });
  }
}

